var authMixin = {
  methods: {
    /**
     * Teste si l'utilisateur courant possède une ou plusieurs autorisations
     * @param {mixed}     authorizations  Chaine de l'autorisation à tester ou tableau des autorisations à tester
     * @param {boolean}   or              True si au moins une autorisation doit être acquise, False si toutes les autorisations doivent être acquises. défault : False
     * @returns {boolean}
     */
    isAuthorized(authorizations, or = false) {
      if (Array.isArray(authorizations)) {
        if (or == true) {
          for (let index in authorizations) {
            if (this.$store.getters['auth/isAuthorized'](authorizations[index])) {
              return true
            }
          }
          return false
        } else {
          for (let index in authorizations) {
            if (this.$store.getters['auth/isAuthorized'](authorizations[index]) != true) {
              return false
            }
          }
          return true
        }
      } else {
        return this.$store.getters['auth/isAuthorized'](authorizations)
      }
    }
  }
}

export default authMixin;



// WEBPACK FOOTER //
// ./src/mixins/auth.js